import { Button, Dialog, DialogActions, DialogTitle, Grid, IconButton, Stack } from '@mui/material'
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded'
import React from 'react'
import CustomTextField from '../common/CustomTextField'
import { ContactDto } from '../../services/api/sharedTypes/Contact'

interface ContactPersonProps {
    id: number
    contactPerson: ContactDto
    onDelete: (index: number) => void
    onEdit: (index: number, editedContactPerson: ContactDto) => void
}

const ContactPerson: React.FC<ContactPersonProps> = ({ id, contactPerson, onDelete, onEdit }: ContactPersonProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const confirmDeleteClient = () => {
        onDelete(id - 1)
        handleCloseDialog()
    }

    const handleNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, nameIndex: number) => {
        const {
            target: { value },
        } = event

        if (nameIndex === 0) {
            onEdit(id, { ...contactPerson, name: `${value} ${contactPerson.name.split(' ')[1] ?? ''}` })
        }
        if (nameIndex === 1) {
            onEdit(id, { ...contactPerson, name: `${contactPerson.name.split(' ')[0] ?? ''} ${value}` })
        }
    }

    return (
        <Stack direction='row-reverse' mb={3}>
            <IconButton color='error' size='small' onClick={handleOpenDialog}>
                <DeleteOutlineRoundedIcon />
            </IconButton>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>Opravdu chcete kontaktní osobu {id} smazat?</DialogTitle>

                <DialogActions>
                    <Button onClick={handleCloseDialog} variant='outlined'>
                        Ne
                    </Button>
                    <Button onClick={confirmDeleteClient} autoFocus variant='contained' color='error'>
                        Ano
                    </Button>
                </DialogActions>
            </Dialog>

            <Grid container rowSpacing={2} columnSpacing={2}>
                <Grid item xs={6}>
                    <CustomTextField
                        fullWidth
                        variant='outlined'
                        size='small'
                        placeholder='Jméno'
                        label='Jméno'
                        value={contactPerson.name.split(' ')[0] ?? ''}
                        onChange={(e) => {
                            handleNameChange(e, 0)
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomTextField
                        fullWidth
                        variant='outlined'
                        size='small'
                        placeholder='Příjmení'
                        label='Příjmení'
                        value={contactPerson.name.split(' ')[1] ?? ''}
                        onChange={(e) => {
                            handleNameChange(e, 1)
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomTextField
                        fullWidth
                        variant='outlined'
                        size='small'
                        placeholder='Telefoní číslo'
                        label='Telefoní číslo'
                        value={contactPerson.phone}
                        onChange={(e) => {
                            onEdit(id, { ...contactPerson, phone: e.target.value })
                        }}
                    />
                </Grid>
                <Grid item xs={6}>
                    <CustomTextField
                        fullWidth
                        variant='outlined'
                        size='small'
                        placeholder='Email'
                        label='Email'
                        value={contactPerson.email}
                        onChange={(e) => {
                            onEdit(id, { ...contactPerson, email: e.target.value })
                        }}
                    />
                </Grid>
            </Grid>
        </Stack>
    )
}

export default ContactPerson
